const mutations = {
  updateNavActive(state, navActive) {
    state.navActive = navActive
  },
}
export default mutations



// WEBPACK FOOTER //
// ./src/store/mutations.js